var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-xs buttonCopy",attrs:{"variant":"outline-info","size":"sm","tabindex":"-1"},on:{"click":function($event){return _vm.copy(_vm.value, _vm.title)}}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }